<div class="att-dialog-card">
  <div class="att-dialog-header">
    <h5 class="att-dialog-title">Search By Admission No</h5>
    <button type="button" class="att-dialog-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="att-dialog-body">
    <form [formGroup]="IPEMARKSForm" class="att-dialog-form">
      <div class="att-dialog-field">
        <label class="att-dialog-label">Start Date</label>
        <div class="date-picker-container" (click)="openFromCalendar($event)">
          <input #fromDateInput type="text" placeholder="DD-MM-YYYY"
            class="form-control att-dialog-input"
            [value]="IPEMARKSForm.get('fromDate')?.value || ''"
            readonly>
          <i class="fa fa-calendar att-date-icon"></i>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">End Date</label>
        <div class="date-picker-container" (click)="openToCalendar($event)">
          <input #toDateInput type="text" placeholder="DD-MM-YYYY"
            class="form-control att-dialog-input"
            [value]="IPEMARKSForm.get('toDate')?.value || ''"
            readonly>
          <i class="fa fa-calendar att-date-icon"></i>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Test Name</label>
        <div class="dropdown w-100">
          <button class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="dropdown-text">{{ selectedtestname || 'Select Test' }}</span>
          </button>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container">
              <input type="text" class="form-control att-search-input" placeholder="Search Test Name"
                [(ngModel)]="testQuery" [ngModelOptions]="{standalone: true}"
                (keyup)="filterTests()" (click)="$event.stopPropagation()">
            </li>
            <li class="list_campus">
              <ng-container *ngFor="let test of filteredTestList">
                <ul class="att-dropdown-item" (click)="selectTest(test)"
                  [class.att-item-selected]="selectedTestCode === test.testCode">
                  <li class="att-item-text">{{ getApiTestDisplayName(test) }}</li>
                  <li><i *ngIf="selectedTestCode === test.testCode" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Admission No</label>
        <div class="ipe-adm-search">
          <input type="text" class="form-control att-dialog-input"
            placeholder="Search By Admission No" [(ngModel)]="searchCriteria"
            [ngModelOptions]="{standalone: true}" maxlength="9"
            (keydown)="onKeydown($event)" appAppAlphanumericOnlyDirective />
          <button type="button" class="ipe-adm-search-btn" (click)="search(searchCriteria)"
            aria-label="Search">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="selectedStudent && (selectedStudent.admNo || selectedStudent.subjects?.length)" class="ipe-student-block">
      <h6 class="ipe-block-title">Student Details</h6>
      <div class="ipe-detail-row">
        <span class="ipe-detail-label">Admission No</span>
        <span class="ipe-detail-value">{{ selectedStudent.admNo || '—' }}</span>
      </div>
      <div class="ipe-detail-row">
        <span class="ipe-detail-label">Name</span>
        <span class="ipe-detail-value">{{ selectedStudent.name || '—' }}</span>
      </div>
      <div class="ipe-detail-row">
        <span class="ipe-detail-label">Section Name</span>
        <span class="ipe-detail-value">{{ selectedStudent.sectionName || '—' }}</span>
      </div>

      <h6 class="ipe-block-title ipe-block-title-gap">Subjects and Max Marks</h6>
      <div class="ipe-marks-table-wrap">
        <table class="ipe-marks-table">
          <thead>
            <tr>
              <th>Subject Name</th>
              <th>Max Marks</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let subject of selectedStudent?.subjects">
              <td>{{ subject?.subjectName }}</td>
              <td>{{ subject?.maxMarks }}</td>
              <td>
                <input type="text" class="form-control att-dialog-input ipe-mark-input"
                  [(ngModel)]="subject.marks"
                  [placeholder]="subject.isReadonly ? 'NC' : ('Enter ' + subject.subjectName + ' Marks')"
                  (input)="validateMarks(subject)"
                  (keypress)="allowOnlyNumbers($event)"
                  [readonly]="isSubjectMarksReadonly(subject)"
                  [class.ipe-mark-readonly]="isSubjectMarksReadonly(subject)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="!selectedStudent && !isLoading && errorMessage && !isFormSubmited"
      class="ipe-alert">
      {{ errorMessage }}
    </div>
  </div>

  <div class="att-dialog-actions" *ngIf="selectedStudent && (selectedStudent.admNo || selectedStudent.subjects?.length)">
    <button type="button" class="att-dialog-btn att-dialog-btn-search"
      [disabled]="!canUpdateMarks"
      [title]="canUpdateMarks ? '' : 'Update permission is not enabled for this role'"
      (click)="studentmarkslist()">Save</button>
  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
